import { gql } from "@apollo/client";

export const UPDATE_PROFESSIONIST = gql`
  mutation updateProfessionist(
    $professionist_id: Int!
    $photo: Upload
    $name: String
    $surname: String
    $is_photo_deleted: Boolean
    $phone: String
    $bio: String
    $studies: String
  ) {
    updateProfessionistProfileInfos(
      professionist_id: $professionist_id
      photo: $photo
      name: $name
      surname: $surname
      is_photo_deleted: $is_photo_deleted
      phone: $phone
      bio: $bio
      studies: $studies
   ) {
      id
    }
  }
`;
export const UPDATE_PATIENT = gql`
  mutation updatePatientProfileInfos(
    $name: String
    $surname: String
    $phone: String
    $bio: String
  ) {
    updatePatientProfileInfos(
      name: $name
      surname: $surname
      phone: $phone
      bio: $bio
   ) {
      id
    }
  }
`;

export const UPDATE_PROFESSIONIST_PASSWORD = gql`
  mutation updatePassword(
    $currentPassword: String!,
    $newPassword: String!,
    $repeatPassword: String!,
  ) {
    updatePassword(
      current_password: $currentPassword,
      new_password: $newPassword,
      repeat_password: $repeatPassword
    )
  }
`;

export const DELETE_USER = gql`
  mutation deleteAccount {
    deleteAccount
  }
`;
